import { JandiLogo } from "@/components/assets/logos/svgs"
import { loadStripe } from "@stripe/stripe-js"
import { useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"
import { api } from "@/utils/api"
import type { Checkout, Quote } from "@/types/stripeTypes"
import { Elements, PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js"

// @ts-expect-error: ImportMeta error
const stripeKey = import.meta.env.VITE_STRIPE_KEY
const stripePromise = loadStripe(stripeKey)

function SetupIntentForm({ clientSecret, onPaymentMethodSaved }: { clientSecret: string, onPaymentMethodSaved: (paymentMethodId: string) => void }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    if (!stripe || !elements) {
      setError("Stripe is not ready.");
      setLoading(false);
      return;
    }
    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {},
      redirect: 'if_required',
    });
    if (result.error) {
      setError(result.error.message || "Setup failed");
    } else if (result.setupIntent?.payment_method) {
      let paymentMethodId = result.setupIntent.payment_method;
      if (typeof paymentMethodId === 'object' && paymentMethodId.id) {
        paymentMethodId = paymentMethodId.id;
      }
      onPaymentMethodSaved(paymentMethodId as string);
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <PaymentElement />
      <button type="submit" disabled={!stripe || loading} className="bg-blue-500 text-white px-6 py-2 rounded-3xl">
        {loading ? "Processing..." : "Add Payment Information"}
      </button>
      {error && <div className="text-red-500 text-sm">{error}</div>}
    </form>
  );
}

export function StripeCheckout({ quoteId, clientSecret: propClientSecret, onPaymentMethodSaved } : { quoteId?: string, clientSecret?: string, onPaymentMethodSaved?: (paymentMethodId: string) => void }) {
  const navigate = useNavigate()
  const [checkout, setCheckout] = useState<Checkout>()
  const [clientSecret, setClientSecret] = useState<string | null>(propClientSecret || null)
  const [isLoading, setIsLoading] = useState<boolean>(!propClientSecret)
  // const [quote, setQuote] = useState<Quote>()

  // If clientSecret is not provided, fallback to quoteId flow
  // useEffect(() => {
  //   if (propClientSecret) return;
  //   if (!quoteId) return;
  //   const fetchData = async () => {
  //     const { quoteData } = await api.getQuoteById({ quoteId })
  //     const { connectedAccount } = await api.getWorkerById(quoteData.supplier.workerProfile.id)
  //     const { client_secret, ...checkout } = await api.createCheckout(quoteData.items, connectedAccount)
  //     setQuote(quoteData)
  //     setCheckout(checkout)
  //     setClientSecret(client_secret)
  //     setIsLoading(false)
  //   }
  //   fetchData()
  // }, [quoteId, propClientSecret])

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" >
        <div className="spinner-border" style={{ height: "50px", width: "50px", color: "var(--primary-color)" }} role="status"></div>
      </div>
    )
  }

  return (
    <div className="flex flex-column justify-content-center align-items-center">
      <div className="p-5 w-full" style={{ background: '#fff', borderRadius: '16px', boxShadow: '0 0 10px rgba(0,0,0,0.2)' }}>
        <JandiLogo className="w-100 mb-6" />
        { clientSecret && propClientSecret ? (
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <SetupIntentForm clientSecret={clientSecret} onPaymentMethodSaved={onPaymentMethodSaved} />
          </Elements>
        ) : clientSecret ? (
          <div>Embedded Checkout not supported for setup intent. Please use a payment flow.</div>
        ) : null}
      </div>
    </div>
  )
}